import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, finalize, map } from "rxjs/operators";
import { Globals } from "../app.globals";

export abstract class AbstractService<T> {
    abstract getApiUrl(): string;
    projectId: number = 0;

    constructor(public http: HttpClient, public globals: Globals) {}

    getAll(filter: string = ""): Observable<T[]> {
        this.showSpinner();
        return this.http.get(this.getApiUrl() + "/getall/" + filter).pipe(
            map((res) => res as T[]),
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    get(id: number): Observable<T> {
        this.showSpinner();
        return this.http.get(this.getApiUrl() + "/" + id).pipe(
            map((res) => res as T),
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    add(entity: T): Observable<number> {
        this.showSpinner();
        return this.http
            .post(this.getApiUrl(), entity, { responseType: "text" })
            .pipe(
                map((res) => {
                    const id = parseInt(res);

                    if (isNaN(id)) {
                        try {
                            res = JSON.parse(res);
                        } finally {
                            return res;
                        }
                    } else return id;
                }),
                catchError(this.handleError),
                finalize(() => this.hideSpinner())
            );
    }

    update(id: number, entity: T): Observable<void | T> {
        this.showSpinner();
        return this.http.put(this.getApiUrl() + "/" + id, entity).pipe(
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    delete(id: number): Observable<void> {
        this.showSpinner();
        return this.http.delete(this.getApiUrl() + "/" + id).pipe(
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    handleError(error: Response): Observable<any> {
        return throwError(
            error || "Server error, please refresh and try again"
        );
    }

    showSpinner() {
        this.globals.showSpinner();
    }

    hideSpinner() {
        this.globals.hideSpinner();
    }

    isSpinnerVisible(): boolean {
        return this.globals.isSpinnerVisible();
    }

    convertDate(date: any): string {
        let value = new Date(date);

        let month =
            value.getMonth() + 1 < 10
                ? "0" + (value.getMonth() + 1)
                : value.getMonth() + 1;

        let day =
            value.getDate() < 10 ? "0" + value.getDate() : value.getDate();

        return value.getFullYear() + "-" + month + "-" + day;
    }
}
